import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { useUpdateOrganizationOnboarding } from '../../../hooks/organization/useUpdateOrganizationOnboarding';
import Button from '../../../react-components/Button';
import InputText from '../../../react-components/InputText';
import Text from '../../../react-components/Text';
import eventsPanel from '../../../services/events';
import { AnimatedStep } from './AnimatedStep';

interface CompanyNameProps {
  onNextStep: () => void;
}

export const CompanyName = ({ onNextStep }: CompanyNameProps) => {
  const { data: organization, success, run: updateOrganization } = useUpdateOrganizationOnboarding();
  const [companyName, setCompanyName] = useState<string>(organization?.label ?? ``);

  useEffect(() => {
    if ((organization?.label ?? ``) !== companyName) {
      setCompanyName(organization?.label ?? ``);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization]);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        onNextStep();
        eventsPanel.onboardingPageView({ page: `companyName`, data: { companyName } });
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <AnimatedStep id="companyNameAnimatedContainer" isVisible={!success}>
      <Grid
        id="companyName"
        container
        direction="column"
        wrap="nowrap"
        style={{ padding: `20px`, maxWidth: `660px`, position: `relative` }}
        className="animate__animated animate__fadeInUp"
      >
        <Grid item>
          <Text variant="h6" intlId="company.onboarding.name.info" />
        </Grid>

        <VSpacer medium />

        <Grid item>
          <InputText
            fieldValue={companyName}
            placeholderIntlId="company.onboarding.name.ph"
            inputContainerStyles={{ width: `100%` }}
            onChange={(text: any) => {
              setCompanyName(text);
            }}
          />
        </Grid>

        <Grid
          item
          container
          direction="row"
          wrap="nowrap"
          alignItems="center"
          justifyContent="center"
          style={{ position: `absolute`, bottom: `-60px` }}
        >
          {companyName.length > 0 && (
            <Button
              intlId="company.onboarding.next"
              style={{
                width: `200px`,
                height: `32px`,
              }}
              onClick={() => {
                updateOrganization({
                  label: companyName,
                });
              }}
            />
          )}
        </Grid>
      </Grid>
    </AnimatedStep>
  );
};
